'use client';

import { useLocale } from 'next-intl';
import { useShouldAnimate } from '@/hooks/use-anim-prefs';
import styles from './loader.module.css';

type LoaderProps = {
  zodiacSign?: string;
  showAllIcons?: boolean;
};
type LoaderLocale = 'pt' | 'en' | 'es';
const LOADER_COPY: Record<LoaderLocale, { title: string; subtitle: string }> = {
  pt: { title: 'Lendo seu céu', subtitle: 'Um instante para recalibrar' },
  en: { title: 'Reading your sky', subtitle: 'A moment to recalibrate' },
  es: { title: 'Leyendo tu cielo', subtitle: 'Un momento para recalibrar' },
};

export default function Loader(_props: LoaderProps = {}) {
  const localeValue = useLocale();
  const locale: LoaderLocale = localeValue === 'pt' || localeValue === 'es' ? localeValue : 'en';
  const copy = LOADER_COPY[locale];
  const { shouldAnimate } = useShouldAnimate();
  return (
    <div aria-live="polite" className={styles.overlay}>
      <div className={styles.content} data-static={shouldAnimate ? 'false' : 'true'}>
        <div aria-hidden="true" className={styles.orbit}>
          <span className={styles.marker} />
        </div>
        <p className={styles.title}>{copy.title}</p>
        <p className={styles.subtitle}>{copy.subtitle}</p>
      </div>
    </div>
  );
}
